export default __webpack_public_path__ + "static/media/_DSC0751.2c204a65.JPG";